<template>
    <div class="board-root h-full smart-list">
        <div v-if="(selectedUserId == 'no-filter' && selectedTagId == 'no-filter')" class="smart-list-card-wrap card-sm">
            <div class="smart-list-card">
                <div class="mobile-icon smart-list-card-icon-holder">
                    <img class="smart-list-card-icon" src="@/assets/images/design-arrow-mobile.svg" alt="">
                </div>
                <div class="desktop-icon smart-list-card-icon-holder">
                    <img class="smart-list-card-icon" src="@/assets/images/design-arrow.svg" alt="">
                </div>
                <p>Filter tasks by User or Tag</p>
                <a href="#" class="show-info-btn-wrapper" @click.prevent="toggleInfoModal">
                    <span>What is this</span>
                    <i class="icon-question-mark"></i>
                </a>
            </div>
        </div>
        <div v-if="isInfoModalShown" @click.self="isInfoModalShown = false" class="smart-list-card-wrap">
            <div class="smart-list-card">
                <h3>This is useful for:</h3>
                <p>- See all your tasks</p>
                <p>- See what your team  work on</p>
                <p>- Never miss  critical tasks</p>
                <!-- <div class="smart-list-video">
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/pqzjDyk4xos?si=mzpUVCb_mQg2_ak7" title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen>
                    </iframe>
                </div> -->
            </div>
        </div>
        <div v-if="loadingTasks" class="loading-tasks">
            Loading Tasks <LoaderAnimationVue color="#fff" />
        </div>
        <div class="loading-tasks" v-else-if="(selectedUserId != 'no-filter' || selectedTagId  != 'no-filter') && totalLists?.length <= 0">
            No Tasks for this user
        </div>
        <BoardContainer
            v-else
            ref="board-container"
            class="board-list"
            @onEditList="onEditList"
            @setVariable="setVariable"
            :board_id_from_task="board_id_from_task"
            :boardOverviewFunc="smartListFilter"
            :task="task"
            :tags="tags"
            :events="events"
            :list="list"
            :edit_modal_toggle="edit_modal_toggle"
            :cacheTimerRenewLock="cacheTimerRenewLock"
            :from_task="from_task"
            :board_id="board_id"
            @closeModalEditTask="closeModalEditTask"
            @tagsUpdate="tagsUpdate"
            @showUploadState="showUploadState"
        >
            <div class="smooth-dnd-container vertical lists">
                <div
                    v-for="(listItem, listIndex) in smartListTasks"
                    :key="listIndex"
                    class="item item-list"
                    :class="'list' + listIndex"
                    :id="listItem.id"
                >
                    <TaskListContainer
                        :listTitle="listItem.title"
                        :tasks="formattedTasks(listItem.tasks)"
                        :listItem="listItem"
                        :corresponding_boards="listItem?.boards"
                        @openEditTask="openEditTask"
                        @setCardPayload="setCardPayload"
                        @dragstart="dragstart"
                        @onCardDrop="onCardDrop"
                    />
                </div>
            </div>
        </BoardContainer>

        <Flash ref="show"/>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import BoardContainer from "@/components/containers/BoardContainer.vue";
import { mapState } from 'vuex';
import TaskListContainer from "@/components/containers/TaskListContainer.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";

export default {
    name: "SmartTask",
    components: {
        Flash,
        BoardContainer,
        TaskListContainer,
        LoaderAnimationVue
    },
    props: ["board_id", "token", "dragScroll"],
    data: function () {
        return {
            task: {
                id: "",
                title: "",
                body: "",
                tags: [],
                is_template: false,
            },
            setAtags: [],
            task_payload: {},
            events: [],
            cacheTimerRenewLock: null,
            board: {
                title: "",
            },
            lock: "",
            list: {
                title: "",
                tags: [],
                listIndex: "",
                boardIndex: "",
                listPosition: "",
                openListOptions: false,
                openNewTask: false
            },
            tags: [],
            edit_modal_toggle: false,
            list_id: "",
            from_task: false,
            board_id_from_task: null,
            selectedUserId: 'no-filter',
            selectedTagId: 'no-filter',
            loadingTasks: false,
            totalLists: null,
            isInfoModalShown: false,
        };
    },
    async mounted() {
        this.tagsSearch()
    },
    methods: {
        tasksInterval(event) {
            //SSE UPDATES NEEDS FOR ALL RELATED FUNCTIONS
            const mapper = {
                "edit_task_title": 'updateTaskTitleEvent',
                "edit_task_body": 'updateTaskDescriptionEvent',
                "edit_task_tags": 'updateTaskTagsEvent',
                "new_task": 'handleNewTaskEvent',
                "move_task": 'handleTaskMoveEvent',
                "comment": 'handleTaskActivityEvent',
                "upload": 'handleTaskActivityEvent',
                "new_list": 'handleNewListEvent',
                "archive_list": 'handleArchiveListEvent',
                "move_list": 'handleMoveListEvent',
                "logwork": 'handleTaskActivityEvent',
                "edit_list_title": 'handleEditListTitle'
            }
            
            try {
                this[mapper[event['type']]](event)
            } catch(e) {}
        },
        handleEditListTitle(event) {
            this.$store.dispatch('editActiveBoardList', {title: event.txt1, list_id: event.list_id})
        },
        handleNewListEvent(event) {
            let list = {
                id: event.list_id,
                title: event.txt1
            }
            this.$store.dispatch('addActiveBoardList', list)
        },
        handleMoveListEvent(event) {
            let data = {
                list_id: event.list_id,
                prev_list_id: event.uint1
            }
            this.$store.dispatch('switchBoardLists', data)
        },
        handleArchiveListEvent(event) {
            this.$store.dispatch('removeList', event.list_id)
        },
        handleTaskActivityEvent(event) {
            this.$store.dispatch('editTaskEvents', event)
        },
        handleTaskMoveEvent(event) {
            let data = {
                list_id: event.list_id,
                task_id: event.task_id,
                prev_task_id: event.uint1
            }
            this.$store.dispatch('moveActiveBoardTask', data)
        },
        handleNewTaskEvent(event) {
            const newTask = {
                id: event.task_id,
                title: event.txt1,
                project_id: event.project_id,
                list_id: event.list_id,
                body: '',
                body_html: '',
                is_template: false,
                tags: "||"
            };

            this.$store.dispatch('addActiveBoardTask', newTask)
        },
        updateTaskTitleEvent(event) {
            this.$store.dispatch('editTask', {
                title: event.txt1,
                list_id: event.list_id,
                id: event.task_id
            })
        },
        updateTaskDescriptionEvent(event) {
            this.$store.dispatch('editTask', {
                body: event.txt1,
                body_html: event.txt1_html,
                list_id: event.list_id,
                id: event.task_id
            })
        },
        updateTaskTagsEvent(event) {
            this.$store.dispatch('editTask', {
                tags: event.txt1.split('|').filter(i => i != ''),
                list_id: event.list_id,
                id: event.task_id
            })
        },
        openEditModal(modalId) {
            this.$refs['board-container'].$refs[modalId].showModal()
        },
        async closeModalEditTask() {
            this.$store.dispatch('editTask', this.editableTask);
            this.edit_modal_toggle = false
            clearInterval(this.cacheTimerRenewLock)

            let newURLSegment = `/smart-board/${this.editableTask.project_id}`;
            var currentState = history.state || {};
            currentState.urlSegment = `/app${newURLSegment}`;
            history.pushState(currentState, '', `/app${newURLSegment}`);
            
            if (this.from_task) {
                this.onEditList()
                this.fromTaskFalse()
                await this.$router.push(newURLSegment);
            }

            const board = this.boards.filter(board => board.id === this.board_id_from_task)[0]
            document.title = board && board.title ? `${board.title} | Goleko` : 'Goleko'
        },
        async openEditTask(task, list) {
            this.task = Object.assign({}, task)
            this.$store.dispatch('setEditableTask', this.task);
            this.$set(this, 'board_id_from_task', task.board_id)

            setTimeout(() => document.title = this.task && this.task.title ? `${this.task.title} | Goleko` : 'Goleko', 500)

            if (list) {
                this.list = list;
            }

            this.getTags()

            var newURLSegment = `/app/tasks/${this.titleToSlug(task.title)}-${task.id}`;
            var currentState = history.state || {};
            currentState.urlSegment = newURLSegment;
            history.pushState(currentState, '', newURLSegment);

            this.openEditModal('edit-task')

            try {
                const response = await api.post(`/task_open`, {id: task.id});
                if (response.data.msg == 'ok') {
                    this.$store.dispatch('setTaskTimeTracker', response.data.data)
                }

            } catch (e) {
                console.error(e);
            }
        },
        listPosition(list, listIndex, boardIndex) {
            this.list.listPosition = list.id;
            this.list.title = list.title;
            this.list.listIndex = listIndex;
            this.list.boardIndex = boardIndex;
            return;
        },
        getTags() {
            if (!this.activeBoard) return
            if (this.board_id && this.boards && !this.from_task) {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            } else {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            }
        },
        titleToSlug(title) {
            let slug = title.toLowerCase();

            slug = slug.replace(/\s+/g, '-');
            slug = slug.replace(/[^a-z0-9\-]/g, '');
            slug = slug.replace(/-+/g, '-');
            slug = slug.replace(/^-+|-+$/g, '');

            return slug;
        },
        async onEditList() {
            await this.getBoards();
            this.getTags();
        },
        setVariable(key, val) {
            this[key] = val
        },
        setCardPayload(payload) {
            this.listsIds = []
            this.task_payload = payload;
        },
        dragstart(dragResult) {

        },
        onCardDrop(list, dropResult) {
            
        },
        async tagsSearch() {
            try {
                let data = {
                    paginate_by: 2000
                };

                const response = await api.post(`/tag_search`, data);

                if(response.status === 200) {
                    this.$store.dispatch('setTags', response.data.data)
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        formattedTasks(tasks) {
            const allUsers = this.boards.flatMap(board => board.members).filter(user => user)
            const usersMap = new Map(allUsers.map(user => [user?.id, user]))
            const tagMap = new Map(this.allTags.map(tag => [tag?.id, tag]))
            
            const updatedTasks = tasks.map(task => {
                let tags = null;
                
                if(typeof task.tags == 'string') {
                    tags = task.tags.split('|')
                            .filter(tag => tag.trim() !== '')
                            .map(tag => {
                                let t = tag.split(':')
                                return {
                                    tagType: t[0],
                                    id: Number(t[1])
                                }
                            })
                            .filter(tag => tag.id)
                            .map(tag => {
                                if(tag.tagType == 'user') {
                                    return {
                                        tagType: tag.tagType,
                                        ...usersMap.get(tag.id)
                                    }
                                }
                                if(tag.tagType == 'tag') {
                                    return {
                                        tagType: tag.tagType,
                                        ...tagMap.get(tag.id)
                                    }
                                }
                            })
                } else if(typeof task.tags == 'array' || (typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'string')) {
                    tags = task.tags
                            .map(tag => {
                                let t = tag.split(':')
                                return {
                                    tagType: t[0],
                                    id: Number(t[1])
                                }
                            })
                            .filter(tag => tag.id)
                            .map(tag => {
                                if(tag.tagType == 'user') {
                                    return {
                                        tagType: tag.tagType,
                                        ...usersMap.get(tag.id)
                                    }
                                }
                                if(tag.tagType == 'tag') {
                                    return {
                                        tagType: tag.tagType,
                                        ...tagMap.get(tag.id)
                                    }
                                }
                            })
                } else if(typeof task.tags == 'object' && task.tags && typeof task.tags[0] == 'object') {
                    tags = task.tags
                } else {
                    tags = []
                }

                return {
                    ...task,
                    tags: tags
                }
            })

            return updatedTasks
        },
        async smartListFilterByTag(tags) {
            this.isInfoModalShown = false
            this.selectedTagId = tags

            let selectedTags = tags.map(tag => `tag:${tag}`)

            tags.forEach(tag => {
                if(this.selectedUserId != 'no-filter' && !this.selectedTagId.includes('no-filter')) {
                    tags = [`user:${this.selectedUserId}`].concat(selectedTags)
                }
                if (this.selectedUserId == 'no-filter' && !this.selectedTagId.includes('no-filter')) {
                    tags = selectedTags
                }
                if (this.selectedTagId.includes('no-filter') && this.selectedUserId != 'no-filter') {
                    tags = [`user:${this.selectedUserId}`]
                }

                if(tag == 'no-filter' && !this.selectedUserId && !this.selectedTagId) {
                    return
                }
            })
            this.loadingTasks = true
            
            await this.listFilterRequest(tags)
        },
        async smartListFilterByUser(tag) {
            this.isInfoModalShown = false
            let tags = [`user:${tag}`]
            this.selectedUserId = tag
            
            if(this.selectedUserId != 'no-filter' && this.selectedTagId != 'no-filter') {
                tags = [`user:${this.selectedUserId}`, `tag:${this.selectedTagId}`]
            }
            if (this.selectedUserId == 'no-filter' && this.selectedTagId != 'no-filter') {
                tags = [`tag:${this.selectedTagId}`]
            }
            if (this.selectedTagId == 'no-filter' && this.selectedUserId != 'no-filter') {
                tags = [`user:${this.selectedUserId}`]
            }

            if(tag == 'no-filter' && !this.selectedUserId && !this.selectedTagId) {
                return
            }
            this.loadingTasks = true
            
            await this.listFilterRequest(tags)
        },
        async listFilterRequest(tags) {
            try {
                let data = {
                    paginate_by: 2000,
                    detailed: true,
                    tags: tags
                };

                const response = await api.post(`/task_overview`, data);

                if(response.status === 200) {
                    this.totalLists = []

                    let lists = {}
                    response.data.data.forEach(list => {
                        let title = list.title.toLowerCase().trim();
                        if(!lists[title]) {
                            lists[title] = []
                        }

                        lists[title].push(list.id)
                    })

                    for(let l in lists) {
                        let obj = {
                            title: l,
                            ids: lists[l],
                            id: lists[l][0],
                            tasks: []
                        }
                        response.data.data.forEach(list => {
                            if(lists[l].includes(list.id)) {
                                obj.tasks = obj.tasks.concat(list.tasks)
                            }
                        })
                        this.totalLists.push(obj)
                    }

                    this.$store.dispatch('setSmartListTasks', this.totalLists)
                    
                    this.loadingTasks = false

                    this.$nextTick(() => this.dragScroll())
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        toggleInfoModal() {
            this.isInfoModalShown = !this.isInfoModalShown;
        },
        async tagsUpdate() {
            let tags = []
            
            if(this.selectedUserId != 'no-filter' && this.selectedTagId != 'no-filter') {
                tags = [`user:${this.selectedUserId}`, `tag:${this.selectedTagId}`]
            }
            if (this.selectedUserId == 'no-filter' && this.selectedTagId != 'no-filter') {
                tags = [`tag:${this.selectedTagId}`]
            }
            if (this.selectedTagId == 'no-filter' && this.selectedUserId != 'no-filter') {
                tags = [`user:${this.selectedUserId}`]
            }

            if(!this.selectedUserId && !this.selectedTagId) {
                return
            }
            
            await this.listFilterRequest(tags)
        },
        showUploadState(files, taskID) {
            this.$emit('showUploadState', files, taskID)
        },
    },
    watch: {
        async $route() {
            this.getTags();
        },
        async smartListTagFilter(newVal) {
            this.smartListFilterByTag(newVal)
        },
        async smartListFilter(newVal) {
            this.smartListFilterByUser(newVal)
        },
    },
    computed: {
        boards() {
            return this.$store.getters.boards
        },
        tasks() {
            return this.$store.getters.tasks
        },
        ...mapState(['smartListFilter', 'smartListTagFilter']),
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        userID() {
            return this.$store.getters.userID
        },
        editableTask() {
            return this.$store.getters.editableTask
        },
        allTags() {
            return this.$store.getters.tags
        },
        smartListTasks() {
            return this.$store.getters.smartListTasks
        }
    },
    destroyed() {
        this.$store.dispatch('setSmartListTasks', [])
    }
};
</script>

<style lang="scss">
.board-root {
    &.smart-list {
        display: flex;
        align-items: flex-start;
        justify-content: stretch;
        overflow: hidden;

        .board-container {
            min-width: 180px;
            flex-grow: 1;
            align-items: flex-start;
        }

        .smooth-dnd-container {
            width: 100%;
        }

        .smart-list-card-wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
            z-index: 9;
            background: var(--prymary-bg);
            backdrop-filter: blur(0px);
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 100%;
            width: 100%;
            border-radius: unset;
            transform: translateX(0);

            &.card-sm {
                align-items: flex-start;
                padding-top: 170px;

                @include media-up(xxl) {
                    padding-top: 270px;
                }

                .smart-list-card {
                    min-height: 0;
                    text-align: center;
                    border-radius: 22px;
                    padding: 12px 30px;
                    position: relative;
                }

                .show-info-btn-wrapper {
                    display: inline-flex;
                }

                p {
                    font-size: 16px;
                    margin-bottom: 10px;
                }
            }
        }

        .smart-list-card {
            max-width: 600px;
            height: fit-content;
            margin: 0 20px;
            padding-top: 20px;

            h3 {
                color: #BB9BFF;
            }

            p {
                margin-bottom: 7px;
            }
        }

        .smart-list-card-icon-holder {
            position: absolute;

            &.mobile-icon {
                transform: translateX(-50%);
                top: -117%;
                left: 50%;
                width: 35px;

                @include media-up(lg) {
                    display: none;
                }

                @include media-up(md) {
                    left: calc(50% - 120px);
                }
            }

            &.desktop-icon {
                top: -100%;
                left: -100%;
                width: 240px;

                @include media-down(lg) {
                    display: none;
                }

                @include media-up(xxl) {
                    top: -210%;
                    left: -210%;
                    width: 380px;
                }
            }
        }

        .item-list {
            height: fit-content;
        }

        .show-info-btn-wrapper {
            width: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
            background: var(--secondary-bg);
            backdrop-filter: blur(6px);
            padding: 6px 10px;
            cursor: pointer;

            i {
                font-size: 23px;
                margin-left: 5px;
            }
        }
    }

    .drop-down-style select {
        border-radius: 0.5rem;
        display: block;
        padding: 0.625rem;
        background-color: rgb(249, 250, 251);
        border: 1px solid rgb(209, 213, 219);
        color: rgb(17, 24, 39);
        font-size: 18px;
        margin-bottom: 16px;
    }

    .card-body {
        padding: 6px !important;
        width: 100%;
        min-height: 50px;
        flex: 1 1 auto;

        a {
            font-size: 12px;
        }
    }

    .card-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: none !important;
    }

    .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
        overflow: visible;
        display: block;
    }

    .card-body:hover .btn-custom {
        color: #000;
        background-color: transparent !important;
        border: none !important;
    }

    /* file  preview size */


    .root {
        padding: 8px !important;
        overflow: hidden !important;
    }

    .btn-split {
        display: flex !important;
        justify-content: space-between;
        padding: 0 !important;
    }

    .btn-split span {
        padding: 4px 8px;
        flex-grow: 1;
        text-align: left;
    }

    .btn-split span:last-of-type {
        border-left: 1px solid #fff;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        flex-grow: 0;
        flex-shrink: 1;
        text-align: center;
        min-width: 40px;
    }
    .item-inner-holder {
        max-width: 250px;
        width: 100%;
    }

    .new-task {
        .btn-holder {
            display: flex;
            margin: 0 -5px;

            .btn {
                margin: 0 5px;
                min-width: 0;
                flex-grow: 1;
            }
        }
    }

    .add-list .new-list-btns {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        .btn {
            min-width: auto;
        }
    }

    .add-list-item {
        margin-bottom: 10px;
        text-transform: capitalize;
        width: 100%;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .board-list {
        padding-top: 0 !important;
    }
}
</style>
